import React from 'react';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Moment from "react-moment";
import { LOADER_RED, LOADER, KEY_FINDINGS_LIS_STORE_NOTES } from '../../utils/constant';
import LS_SERVICE from '../../utils/localStorage';
import { Popover, Modal, Button, Form, Input, notification, Checkbox, Tooltip } from 'antd';
import {
  SettingFilled, FileOutlined, CloseOutlined
} from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRadiationAlt } from '@fortawesome/free-solid-svg-icons'
import { string } from 'prop-types';
import Axios from 'axios';
import { asyncScheduler } from 'rxjs';
import { Line } from 'react-chartjs-2';
import './key-findings-cumulative.scss';


class KeyFindingsNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '', 
      selectedKeyFindingGraph: props.selectedKeyFindingGraph ?? {},
      keyFindingsNewDataFormatted: props.keyFindingsNewDataFormatted ?? {},
      keyfindingDates: props?.keyFindingsNewDataFormatted?.kfdates ?? [],
      keyfindingDepartments: props?.keyFindingsNewDataFormatted?.departmentTypes ?? [],
      keyfindingHospitals: props?.keyFindingsNewDataFormatted?.hospitalNames ?? [],
      keyfindingDatesFormatted: props?.keyFindingsNewDataFormatted?.kfdates?.slice(0, 5) ?? [],
      chartDataGroup: props.keyFindingsNewDataFormatted?.chartDataGroup ?? {},
      kfDisplayData: props.keyFindingsNewDataFormatted?.kfDisplayData ?? {},
      kfDisplayDataNonNumeric: props.keyFindingsNewDataFormatted?.kfDisplayDataNonNumeric ?? {},
      kfDisplayDataInv: props.keyFindingsNewDataFormatted?.kfDisplayDataInv ?? {},
      path: null,
      showViewerModal: false,
      impression_notes: '',
      showNotesModal: false,
      sample_id: null,
      notesSaved: false,
      index: 0,
      selectedKeysArr: [],
      copyToDSArr: [],
      copyToDSFormattedArr: {}
    }

    this.notesRef = React.createRef();
  }

  async componentDidMount() {
    let kfDataToCopyObj = this.props.kfDataToCopyObj;    
    if(Object.keys(kfDataToCopyObj).length) {
      let resultArray = [];
      Object.keys(kfDataToCopyObj).forEach(key => {
        resultArray = resultArray.concat(kfDataToCopyObj[key]);
      });

      let selectedKeysArr = [];
      Object.keys(kfDataToCopyObj).forEach(item => {
        let keySplit = item.split(' | ')[1];
        selectedKeysArr.push(keySplit);
      });

      this.setState({copyToDSArr: resultArray, copyToDSFormattedArr: kfDataToCopyObj, selectedKeysArr});
    }
  }

  onViewClick(path) {
    this.setState({
      path: path,
      showViewerModal: true
    });
  }

  handleNotesPopup(sample_id, impression_notes) {
    this.setState({ sample_id: sample_id, impression_notes: impression_notes, showNotesModal: true, });
  }

  onSaveNotes(values, sample_id) {

    // let Url = MHEA_API_BASE_URL + "API/ServiceOrder/UpdateImpression";

    let data = {
      lis_sampledata_id: sample_id,
      impression: values.notes,
      enteredById: LS_SERVICE.get('staff_id')
    }

    this.setState({ notesSaved: true, impression_notes: values.notes });

    Axios.post(KEY_FINDINGS_LIS_STORE_NOTES, data)
      .then(res => {
        let response = res.data.data;
        if (response.statusCode == 200) {
          this.setState({ showNotesModal: false, notesSaved: false });
          notification.success({
            message: "Notes saved successfully!",
            placement: 'topRight'
          })
          // this.notesRef.current.setFieldsValue({
          //   notes: null
          // });
        }
      }).catch(err => {
        this.setState({ showNotesModal: false, notesSaved: false });
        // this.notesRef.current.setFieldsValue({
        //   notes: null
        // });
        notification.error({
          message: "Something Went Wrong!",
          placement: 'topRight'
        })
        console.log("Error", err);
      })
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (prevState.keyFindingsNewDataFormatted !== nextProps.keyFindingsNewDataFormatted) {
      return {
        keyFindingsNewDataFormatted: nextProps?.keyFindingsNewDataFormatted,
        keyfindingDatesFormatted: nextProps?.keyFindingsNewDataFormatted?.kfdates.slice(0, 5),
        chartDataGroup: nextProps?.keyFindingsNewDataFormatted?.chartDataGroup ?? {},
        kfDisplayData: nextProps?.keyFindingsNewDataFormatted?.kfDisplayData ?? {},
        kfDisplayDataNonNumeric: nextProps?.keyFindingsNewDataFormatted?.kfDisplayDataNonNumeric ?? {},
        kfDisplayDataInv: nextProps?.keyFindingsNewDataFormatted?.kfDisplayDataInv ?? {},
      };
    }
    return null;
  }

  onClickArrow = async (arrow_type) => {
    const { keyfindingDates, keyfindingDatesFormatted } = this.state;
    var size = 5;
    if (arrow_type == 'next') {
      await this.setState({ index: this.state.index + size });
      while (this.state.index >= keyfindingDates?.length) {
        this.setState({ index: this.state.index - size });
      };
      let nextDates = keyfindingDates.slice(this.state.index, this.state.index + size);
      this.setState({ keyfindingDatesFormatted: nextDates });
    }

    if (arrow_type == 'previous') {
      await this.setState({ index: this.state.index - size });
      while (this.state.index < 0) {
        this.setState({ index: this.state.index + size });
      };
      let prevDates = keyfindingDates.slice(this.state.index, this.state.index + size);
      this.setState({ keyfindingDatesFormatted: prevDates });
    }
  }

  GET_RANGE_CLASS = (status) => {
    if (status == "-") return "";
    let vitalRange = "";
    //normal range
    if (status == 'N')
      vitalRange = "text-success";

    //abnormal range
    if (
      status == 'P'
    )
      vitalRange = "text-danger";

    //critical range
    if (
      status == 'A' || status == 'L' || status == 'H'
    )
      vitalRange = "text-warning";

    return vitalRange;
  };

  getTestValue (testValue){

    const isHtml = /<[^>]+>/g.test(testValue);

    return isHtml ? (
      <span dangerouslySetInnerHTML={{ __html: testValue }} />
    ) : (
      <span>{testValue}</span>
    );
  }

  handleColumnCheckbox(e, date, department) {
    let { copyToDSArr } = this.state;

    if (e.target.checked) {
      let { keyFindingsNewDataFormatted, kfDisplayData } = this.state;
      let headings = typeof keyFindingsNewDataFormatted?.kfDisplayData != 'undefined' ? Object.keys(keyFindingsNewDataFormatted?.kfDisplayData) : [];
      let nonNumericHeadings = typeof keyFindingsNewDataFormatted?.kfDisplayDataNonNumeric != 'undefined' ? Object.keys(keyFindingsNewDataFormatted?.kfDisplayDataNonNumeric) : [];
      let invHeadings = typeof keyFindingsNewDataFormatted?.kfDisplayDataInv != 'undefined' ? Object.keys(keyFindingsNewDataFormatted?.kfDisplayDataInv) : [];

      headings?.length && headings.forEach((kf, k2) => {
        let subHeadings = Object.keys(kfDisplayData[kf]);
        subHeadings.length && subHeadings.forEach(sh => {
          let testValue = kfDisplayData[kf][sh][date]?.test_value;
          if (testValue) {
            let isNormal = kfDisplayData[kf][sh][date]?.isNormal;
            let kfObj = {
              date, department, testValue,
              heading: kf,
              subHeading: sh,
              isNormal: this.GET_RANGE_CLASS(isNormal),
              UOM: kfDisplayData[kf][sh]?.UOM,
              referenceRange: kfDisplayData[kf][sh]?.reference_range,
              selected: false,
            };
            copyToDSArr.push(kfObj);
          }
        })
      })
    }
    else {
      var copyToDSArr1 = copyToDSArr; // initilize
      copyToDSArr = copyToDSArr1.filter(item => item.date != date);
    }

    // Group by "heading | department - date"
    const copyToDSFormattedArr = copyToDSArr.reduce((acc, item) => {
      const key = `${item.heading} | ${item.department} - ${item.date}`;
      // Initialize the array for the current key if it doesn't exist
      if (!acc[key]) { acc[key] = []; }
      // Add the current item to the array for the key
      acc[key].push(item);
      return acc;
    }, {});

    let selectedKeysArr = [];
    Object.keys(copyToDSFormattedArr).forEach(item => {
      let keySplit = item.split(' | ')[1];
      selectedKeysArr.push(keySplit);
    });

    this.setState({ copyToDSArr, copyToDSFormattedArr, selectedKeysArr });
  }

  handleCheckAll(heading, e) {
    this.setState((prevState) => {
      const updatedTestResults = { ...prevState.copyToDSFormattedArr };
      const selectedItem = updatedTestResults[heading];
      for (let index = 0; index < selectedItem.length; index++) {
        // Toggle the 'selected' property of the item
        selectedItem[index].selected = e;        
      } 
      return { copyToDSFormattedArr: updatedTestResults };
    });
  }  

  handleCheck(heading, index) {
    this.setState((prevState) => {
      const updatedTestResults = { ...prevState.copyToDSFormattedArr };
      const selectedItem = updatedTestResults[heading][index];
      
      // Toggle the 'selected' property of the item
      selectedItem.selected = !selectedItem.selected;
  
      return { copyToDSFormattedArr: updatedTestResults };
    });
  }  

  submitKeyFinding(type) {
    if(type==="keyFinding"){
      let {copyToDSFormattedArr} = this.state;
      let insertNoneHtml = "";
      let appenedKFtHtml = "";
  
      // CHECK ANY SELECT OR NOT
      let hasSelectedTests = Object.keys(copyToDSFormattedArr).some(dateKey => copyToDSFormattedArr[dateKey].some(test => test.selected === true));
      // if(!hasSelectedTests) {
      //   notification.destroy();
      //   notification.error({
      //     message: "Select any key finding value to show in print",
      //     placement: 'topRight'
      //   });
      //   return;
      // }
  
      Object.keys(copyToDSFormattedArr).map((kfhData, kfhKey) => {
        let splitHedaing = kfhData.split(' | ')[0];
        let splitDate = kfhData.split(' - ')[1];
        let className = splitHedaing.replace(/\s/g, "_");
        let kfText = "";
  
        let hasSelectedTests = copyToDSFormattedArr[kfhData].some(test => test.selected === true);
        if(hasSelectedTests) {
          copyToDSFormattedArr[kfhData].forEach(kfshObj => {
            if(kfshObj.selected) {
              kfText += `${kfshObj.subHeading}: ${kfshObj.testValue} ${kfshObj.UOM}, `;
            }
          });
          
          kfText = kfText.replace(/,\s*$/, "");
          appenedKFtHtml += '<div key="' + kfhKey + '" class="' + className + '"><b>' + splitHedaing + '&nbsp; (' + splitDate + ') :</b>&nbsp;' + kfText + insertNoneHtml + '</div>';
        }
      });
  
      this.props.handleKFDataCopyToTemplate(hasSelectedTests ? copyToDSFormattedArr : null, appenedKFtHtml, null, true);
    }else if(type==="keyGraph"){
      this.props.handleKFDataCopyToTemplate(null, null, this.props.selectedKeyFindingGraph, false);
    }
  }
  // Function to handle search input change
  handleSearchChange = (e) => {
    const {kfDisplayData,searchQuery,keyFindingsNewDataFormatted} = this.state;
    const formattedData = [];

    Object.keys(keyFindingsNewDataFormatted.kfDisplayData).forEach((section_name) => {
    const tests = keyFindingsNewDataFormatted.kfDisplayData[section_name];
    Object.keys(tests).forEach(test_name => {
    const testData = tests[test_name];
    const {UOM,reference_range,...dynamicDateObject} = testData;
    const dateKey = Object.keys(dynamicDateObject);

    dateKey.forEach((date) => {
      const {test_value,isNormal,confidential_report_release_hold} = dynamicDateObject[date];
      formattedData.push({
      section_name,
      test_name,
      testValue: test_value,
      isNormal,
      confidential_report_release_hold,
      UOM,
      reference_range,
      reportDate: date
           });
        })
      })
    })
      const filteredData = formattedData.filter((item) => {
      return (
      item.section_name.toLowerCase().includes(e.target.value.toLowerCase())  ||
      item.test_name.toLowerCase().includes(e.target.value.toLowerCase()) 
      );
    });

      let formattedDataObject = {}
      filteredData.forEach(data => {
      if(!(data.section_name in formattedDataObject)){
          formattedDataObject[data.section_name]={
          [data.test_name]:{
            [data.reportDate]:  {
            confidential_report_release_hold:data.confidential_report_release_hold,
            isNormal:data.isNormal,
            test_value:data.testValue 
        },
            UOM: data.UOM,
            reference_range: data.reference_range
          }
        }
      }
      else {
        if(!([data.test_name] in formattedDataObject[data.section_name])){
          formattedDataObject[data.section_name][data.test_name] = {
          [data.reportDate]: {
          confidential_report_release_hold: data.confidential_report_release_hold,
          isNormal: data.isNormal,
          test_value: data.testValue
        },
        UOM: data.UOM,
        reference_range: data.reference_range
      };
        }
        else if(!([data.reportDate] in formattedDataObject[data.section_name][data.test_name])){
        formattedDataObject[data.section_name][data.test_name][data.reportDate] = {
        confidential_report_release_hold: data.confidential_report_release_hold,
        isNormal: data.isNormal,
        test_value: data.testValue
      };
    }
        
      }
    })

    const formattedData_non_numeric = [],formattedData_non_numeric_headings = [];
    if(e.target.value){
        Object.keys(keyFindingsNewDataFormatted.kfDisplayDataNonNumeric).forEach(section_name => {
      if(section_name.toLowerCase().includes(e.target.value.toLowerCase())){
        formattedData_non_numeric_headings.push(section_name)
        formattedData_non_numeric.push({
          [section_name]:keyFindingsNewDataFormatted.kfDisplayDataNonNumeric[section_name]
        })
      }
    })
    }
  
    const formattedData_non_numeric_object = {};
    formattedData_non_numeric_headings.forEach(section_name=>{
      formattedData_non_numeric_object[section_name] = keyFindingsNewDataFormatted.kfDisplayDataNonNumeric[section_name]
    })


    if(!e.target.value){
      this.setState({ searchQuery: e.target.value,
      kfDisplayData:keyFindingsNewDataFormatted.kfDisplayData,
      kfDisplayDataNonNumeric:keyFindingsNewDataFormatted.kfDisplayDataNonNumeric
     });
    }
    else{
        this.setState({ searchQuery: e.target.value,
        kfDisplayData:formattedDataObject,
        kfDisplayDataNonNumeric:formattedData_non_numeric_object
     });
    }
  };

  filterKeyFindings = (kfDisplayData, kf) => {
    const data = kfDisplayData[kf] || {};
    return data;
  };
  

  render() {
    const selectedKeyFindingGraph = this.props.selectedKeyFindingGraph;
    const { keyfindingDates, keyfindingDatesFormatted, chartDataGroup, kfDisplayData, kfDisplayDataNonNumeric, kfDisplayDataInv, copyToDSArr, copyToDSFormattedArr, selectedKeysArr } = this.state;
    let headings = typeof this.state.keyFindingsNewDataFormatted?.kfDisplayData != 'undefined' ? Object.keys(this.state.kfDisplayData) : [];
    let nonNumericHeadings = typeof this.state.keyFindingsNewDataFormatted?.kfDisplayDataNonNumeric != 'undefined' ? Object.keys(this.state.kfDisplayDataNonNumeric) : [];
    let invHeadings = typeof this.state.keyFindingsNewDataFormatted?.kfDisplayDataInv != 'undefined' ? Object.keys(this.state.keyFindingsNewDataFormatted?.kfDisplayDataInv) : [];

    return (
      <>
        <div className="card-body vitals"  style={{borderTop:'0px', padding: '0px'}} >
          <div className="row">
             <div style={{position: 'absolute', top: '-54px', left: '0px', zIndex: '999999', display: 'flex', alignItems: 'flex-start'}} 
                  className="antInputItem">
                  <div className="form-group kf-search-wrap" style={{ width: '300px' }}>
                    <input
                      type="text"
                      placeholder="Search..."
                      aria-label="Search key findings"
                      className="form-control"
                      value={this.state.searchQuery}
                      onChange={this.handleSearchChange}
                    />
                    {this.state.searchQuery ? (
                      <button
                        type="button"
                        className="kf-search-clear"
                        aria-label="Clear search"
                        title="Clear search"
                        // Reuse the search handler so the table resets to the full data
                        onClick={() => this.handleSearchChange({ target: { value: '' } })}
                      >
                        <CloseOutlined />
                      </button>
                    ) : null}
                  </div>
                  {/* ORDER DATE / RESULT DATE selector passed in by the parent */}
                  {this.props.dateTypeSelector ? (
                    <div className="kf-date-type ml-3" style={{ marginTop: '8px' }}>
                      {this.props.dateTypeSelector}
                    </div>
                  ) : null}
                </div>
            <div
              className={`table-responsive ${copyToDSArr.length ? 'col-8' : 'col-12'}`}
              style={{ padding: "0px" }}
            >
              <div className='fixed-table custom-scrollbar' style={{height: '700px'}}>
               
                <table className="table" style={{lineHeight: '1.2'}} >
                  <tbody>
                    {typeof keyfindingDatesFormatted != 'undefined' && keyfindingDatesFormatted?.length > 0 ?
                      <tr>
                        <th style={{verticalAlign: 'middle', width: '20%'}} className='py-1'>Parameter
                          <span disabled="disabled" className="" style={{ position: 'absolute', right: '3px', top: "24px" }}>
                            <a >
                              <span disabled className="float-right chevron chevron-left arrow-left"
                                onClick={() => this.onClickArrow('previous')}
                              />
                            </a>
                          </span>
                        </th>
                        {
                          keyfindingDatesFormatted.map((v, i) => (
                            <th key={i} className={`pl-0 pr-0 py-1`} style={{ maxWidth: "250px" }}>
                              <div className="row">
                                {/* Facility name shows on hover over the department + date/time block */}
                                <Tooltip
                                  title={this.state.keyfindingHospitals[i] ? `FACILITY : ${this.state.keyfindingHospitals[i]}` : null}
                                  color="#fff"
                                  overlayClassName="kf-facility-tooltip"
                                  overlayInnerStyle={{ fontSize: '15px' }}
                                >
                                <div
                                  className="col-12 text-center vital-time"
                                  style={this.state.keyfindingHospitals[i] ? { cursor: 'pointer', backgroundColor: 'white', padding: '5px 1px' } : { backgroundColor: 'white', padding: '5px 1px' }}
                                >
                                  <div>
                                    {this.props.pageFrom == 'KeyFindings' ? 
                                      <Checkbox
                                      style={{margin:'0px 5px'}}
                                      checked={selectedKeysArr.includes(`${this.state.keyfindingDepartments[i]} - ${v}`)} 
                                      disabled ={this.state.searchQuery}
                                      onClick={(e) => this.handleColumnCheckbox(e, v, this.state.keyfindingDepartments[i])}>
                                     </Checkbox> : null}
                                    {this.state.keyfindingDepartments[i]}
                                  </div>
                                 {v ? v?.split(' ').slice(0, 3).join(' ') : ""} | {v ? v?.split(' ').slice(3).join(' ') : ""}
                                </div>
                                </Tooltip>
                              </div>
                            </th>
                          ))
                        }
                        <th className="text-center text-bold py-1" style={{ width: '132px' }}>
                          Reference<br/>Range
                          <span disabled="disabled" className="" style={{ position: 'absolute', left: '-7px', top: "24px" }}>
                            <a >
                              <span disabled={keyfindingDatesFormatted?.length > 5 ? true : false} className="float-right chevron chevron-right arrow-right"
                                onClick={() => this.onClickArrow('next')}
                              />
                            </a>
                          </span>
                        </th>
                        <th style={{verticalAlign: 'middle', width: '22px'}} className="text-center text-bold py-1">Trend</th>
                      </tr>
                      : <tr><td className="pt-2">No Record Found</td></tr>}

                    {/* Numeric GRP*/}
                    {
                      typeof keyfindingDatesFormatted != 'undefined' && keyfindingDatesFormatted?.length > 0 ?
                        typeof headings != 'undefined' && headings?.length > 0 ?
                          headings.map((kf, k2) => {
                            let kfDisplayDatanew =  this.filterKeyFindings(kfDisplayData, kf);
                            let subHeadings = Object.keys(kfDisplayDatanew);
                            let testData = this.state.chartDataGroup[kf];
                            return (
                              <React.Fragment key={k2}>
                                <tr>
                                  <td className={`text-bold py-1`}>{kf}</td>
                                  {
                                    keyfindingDatesFormatted.map(date => {
                                      return (<td></td>)
                                    })
                                  }
                                  <td  className='py-1'></td>
                                  <td  className='py-1'>
                                    <button
                                      type="button"
                                      className="btn chart-btn button-chart-individual p-0"
                                      onClick={e => this.props.handleModalPopupStateLift(e, 'keyFindingChartModalNew', { type: 'finding-group', name: 'Key Findings Trend Graphs', testData, testName: kf })}
                                    >
                                      <i style={{width: '20px', height: '20px'}} className="icon-chart"></i>
                                    </button>
                                  </td>
                                </tr>
                                {
                                  typeof subHeadings != 'undefined' && subHeadings?.length > 0 ?
                                    subHeadings.map(sh => {
                                      let refDate;
                                      let isNormal;
                                      let testName;
                                      let testDataIndividual;
                                      return (
                                        <>
                                          <tr>
                                            <td className='py-1'>{sh}</td>
                                            {
                                              keyfindingDatesFormatted.map(date => {
                                                refDate = date;
                                                isNormal = kfDisplayData[kf][sh][date]?.isNormal;
                                                testName = sh;
                                                testDataIndividual = this.state.chartDataGroup[kf];
                                                if (typeof kfDisplayData[kf][sh][date]?.test_value != undefined && kfDisplayData[kf][sh][date]?.test_value != "") {
                                                  return (
                                                    <td className={`text-center py-1`}>
                                                      <span style={{ maxWidth: '114px', width: '114px', fontSize: '18px', fontWeight: (isNormal == 'P' || isNormal == 'A' || isNormal == 'L' || isNormal == 'H') ? '500' : 'normal' }} className={`${this.GET_RANGE_CLASS(isNormal)}`}>
                                                        {kfDisplayData[kf][sh][date]?.test_value != null && kfDisplayData[kf][sh][date]?.test_value != "" ? this.getTestValue(kfDisplayData[kf][sh][date]?.test_value) : '-'}
                                                      </span>
                                                      <span style={{ maxWidth: '114px', width: '114px', fontSize: '18px', fontWeight: (isNormal == 'P' || isNormal == 'A' || isNormal == 'L' || isNormal == 'H') ? '500' : 'normal' }} className="ml-2">
                                                        {kfDisplayData[kf][sh][date]?.test_value != null && kfDisplayData[kf][sh][date]?.test_value != "" ? `${kfDisplayData[kf][sh]?.UOM || ''}` : ''}
                                                      </span>
                                                    </td>
                                                  )
                                                } else {
                                                  return (
                                                    <td className='text-center'>-</td>
                                                  )
                                                }
                                              })
                                            }
                                            <td className='text-center py-1'><div dangerouslySetInnerHTML={{ __html: kfDisplayData[kf][sh]?.reference_range }} /></td>
                                            {/* <td className='text-center'><div dangerouslySetInnerHTML={{ __html: kfDisplayData[kf][sh]?.reference_range }} />{kfDisplayData[kf][sh]?.UOM != "" ? "" : ""}</td> */}
                                            <td className='py-1'>
                                              <button
                                                type="button"
                                                className="btn chart-btn button-chart-individual p-0"
                                                onClick={e => this.props.handleModalPopupStateLift(e, 'keyFindingChartModalNew', { type: 'individual', id: 1, name: 'Key Findings Trend Graphs', isNormal, testDataIndividual, testName })}
                                              >
                                                <i style={{width: '20px', height: '20px'}} className="icon-chart"></i>
                                              </button>
                                            </td>
                                          </tr>
                                        </>
                                      )
                                    })
                                    : null
                                }
                              </React.Fragment>
                            );
                          })
                          : null
                        : null
                    }

                    {/* Numeric INV*/}
                    {
                      typeof keyfindingDatesFormatted != 'undefined' && keyfindingDatesFormatted?.length > 0 ?
                        typeof invHeadings != 'undefined' && invHeadings?.length > 0 ?
                          invHeadings.map((ikf, k2) => {
                            let refDate;
                            let isNormal;
                            let testName;
                            let testDataIndividual = this.state.chartDataGroup[ikf];
                            let testObj = {};
                            testObj[ikf] = testDataIndividual;
                            return (
                              <React.Fragment key={k2}>
                                {
                                  <tr>
                                    <td className={`text-bold`}>{ikf}</td>
                                    {
                                      keyfindingDatesFormatted.map(date => {
                                        refDate = date;
                                        isNormal = kfDisplayDataInv[ikf][date]?.isNormal;
                                        testName = ikf;

                                        if (typeof kfDisplayDataInv[ikf][date]?.test_value != undefined && kfDisplayDataInv[ikf][date]?.test_value != "") {
                                          return (
                                            <td className={`text-center py-1`}>
                                              <span style={{ maxWidth: '114px', width: '114px', fontSize: '18px', fontWeight: (isNormal == 'P' || isNormal == 'A' || isNormal == 'L' || isNormal == 'H') ? '500' : 'normal' }} className={`${this.GET_RANGE_CLASS(isNormal)}`}>
                                                {kfDisplayDataInv[ikf][date]?.test_value != null && kfDisplayDataInv[ikf][date]?.test_value != "" ? this.getTestValue(kfDisplayDataInv[ikf][date]?.test_value) : '-'}
                                              </span>
                                              <span style={{ maxWidth: '114px', width: '114px', fontSize: '18px', fontWeight: (isNormal == 'P' || isNormal == 'A' || isNormal == 'L' || isNormal == 'H') ? '500' : 'normal' }} className="ml-2">
                                                {kfDisplayDataInv[ikf][date]?.test_value != null && kfDisplayDataInv[ikf][date]?.test_value != "" ? `${kfDisplayDataInv[ikf]?.UOM || ''}` : ''}
                                              </span>
                                            </td>
                                          )
                                        } else {
                                          return (
                                            <td className='text-center py-1'>-</td>
                                          )
                                        }
                                      })
                                    }
                                    <td className='text-center py-1'><div dangerouslySetInnerHTML={{ __html: kfDisplayDataInv[ikf]?.reference_range }} />{kfDisplayDataInv[ikf]?.UOM != "" && kfDisplayDataInv[ikf]?.UOM != null ? `( ${kfDisplayDataInv[ikf]?.UOM} )` : ""}</td>
                                    {/* <td className='text-center'><div dangerouslySetInnerHTML={{ __html: kfDisplayDataInv[ikf]?.reference_range }} />{kfDisplayDataInv[ikf]?.UOM != "" && kfDisplayDataInv[ikf]?.UOM != null ? "" : ""}</td> */}
                                    <td  className='py-1'>
                                      <button
                                        type="button"
                                        className="btn chart-btn button-chart-individual"
                                        onClick={e => this.props.handleModalPopupStateLift(e, 'keyFindingChartModalNew', { type: 'individual', id: 1, name: 'Key Findings Trend Graphs', isNormal, testDataIndividual: testObj, testName })}
                                      >
                                        <i className="icon-chart" style={{width: '20px', height: '20px'}} ></i>
                                      </button>
                                    </td>
                                  </tr>

                                }
                              </React.Fragment>
                            );
                          })
                          : null
                        : null
                    }

                    {/* Non Numeric*/}
                    {
                      typeof keyfindingDatesFormatted != 'undefined' && keyfindingDatesFormatted?.length > 0 ?
                        typeof nonNumericHeadings != 'undefined' && nonNumericHeadings?.length > 0 ?
                          nonNumericHeadings.map((kf, k2) => {
                            return (
                              <React.Fragment key={k2}>
                                <tr>
                                  <td className={`text-bold py-1`}>{kf}</td>
                                  {
                                    keyfindingDatesFormatted.sort().reverse().map(date => {
                                      let image = kfDisplayDataNonNumeric[kf][date]?.imageURL
                                      let result = kfDisplayDataNonNumeric[kf][date]?.result_pdf
                                      let lis_sampledata_id = kfDisplayDataNonNumeric[kf][date]?.lis_sampledata_id
                                      let impression_notes = kfDisplayDataNonNumeric[kf][date]?.impression
                                      if (typeof image != undefined || typeof result != undefined) {
                                        return (<td className='text-center non-numeric-td py-1' style={{ maxWidth: '114px', width: '114px' }}>
                                          {
                                            image != "" && image != null ?
                                              <a className='non-numeric-a' style={{ marginRight: '11px', color: 'red', textDecoration: 'underline' }}
                                                href={image} target="_blank" rel="noopener noreferrer"
                                                // onClick={() => this.onViewClick(image)}
                                              ><FontAwesomeIcon icon={faRadiationAlt} className="text-warning cursor-p" style={{ fontSize: '17px' }} /></a>
                                              : null
                                          }

                                          {
                                            result != "" && result != null ?
                                              <a className='non-numeric-a text-success' style={{ marginRight: '11px' }} href={result} target="_blank" rel="noopener noreferrer">Resulted</a>
                                              : null
                                          }

                                          {
                                            (image != "" && image != null) || (result != "" && result != null) ?
                                              <a className='non-numeric-a' title={impression_notes} onClick={() => this.handleNotesPopup(lis_sampledata_id, impression_notes)}><FileOutlined /></a> :
                                              null
                                          }

                                        </td>)
                                      } else {
                                        return (<td className='py-1'>-</td>)
                                      }

                                    })
                                  }
                                </tr>
                              </React.Fragment>
                            );
                          })
                          : null
                        : null
                    }
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-4" style={copyToDSArr.length ? { padding: "0px" } : { display: "none" }}>
              <div className='fixed-table' style={{height: '675px'}} >
                {copyToDSArr.length && Object.keys(copyToDSFormattedArr).map(kfKey => {
                  return (
                    <>
                      <div className='font-weight-bold text-center  d-flex' style={{ paddingTop: "5px",paddingBottom: "5px", }}>
                        <div className='col-1'>
                          <Checkbox type='checkbox' onClick={(e) => this.handleCheckAll(kfKey, e.target.checked)} ></Checkbox>
                        </div>
                        <div className='col-11'>
                          <label>{kfKey}</label> 
                        </div>
                      </div>
                    

                      <table style={{lineHeight: '1.2'}}  className="table table-bordered">
                        <tbody>
                          <tr>
                            <th className='py-1' width="50%">Parameter</th>
                            <th className='py-1' width="20%">Value</th>
                            <th className='py-1' width="30%">Reference Range</th>
                          </tr>
                          {copyToDSFormattedArr[kfKey].map((kfObj, kfIndex) => (
                            <>
                              <tr>
                                <td>
                                  <div onClick={() => this.handleCheck(kfKey, kfIndex)}>
                                    <Checkbox type='checkbox' style={{ cursor: 'pointer', marginRight:"10px", }} checked={kfObj.selected} defaultChecked={kfObj.selected} ></Checkbox>
                                    &nbsp; &nbsp;
                                    <label>{kfObj.subHeading}</label> 
                                  </div>
                                </td>
                                <td className={kfObj.isNormal}>{kfObj.testValue}</td>
                                <td>{kfObj.referenceRange} {kfObj.UOM ? `(${kfObj.UOM})` : null}</td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </>
                  )
                })}
              </div>
              <div className="row my-2 mr-2">
                <div className="col-12 text-right">
                  <Button type="primary" htmlType="submit" onClick={()=>this.submitKeyFinding("keyFinding")} className="btn btn-sm btn-primary">ADD DATA TO PRINT</Button>
                </div>
              </div>
            </div>


          </div>
        </div>  

        {/* For Viewing Material */}
        <Modal
          visible={this.state.showViewerModal}
          footer={false}
          width={850}
          onCancel={() => { this.setState({ showViewerModal: false, pdfPath: null, index: 0 }) }}
          style={{ top: 20 }}
        >
          <div className="row">
            <div className="col-12 my-3 text-center">
              {this.state.path != null ? <iframe src={this.state.path} frameBorder="0" scrolling="no" style={{ overflow: 'hidden' }} width="100%" height="700">
                {LOADER_RED}
              </iframe> : null}
            </div>
          </div>
        </Modal>

        <Modal
          visible={this.state.showNotesModal}
          footer={false}
          width={600}
          onCancel={() => { this.setState({ showNotesModal: false }) }}
          style={{ top: 20 }}
        >
          <Form ref={this.notesRef} layout='vertical' onFinish={(val) => this.onSaveNotes(val, this.state.sample_id)}>
            <Form.Item label="Notes" type='text' name='notes' className='mt-3' style={{ marginTop: '1rem' }}>
              <Input autoComplete="off" autoFocus={true} value={this.state.impression_notes} defaultValue={this.state.impression_notes} />
            </Form.Item>
            <div className='text-center' style={{ marginTop: '1rem' }}>
              <button disabled={this.state.notesSaved} type='Submit' className="btn btn-primary">
                Save {!this.state.notesSaved ? "" : LOADER}
              </button>
            </div>
          </Form>
        </Modal>
      </>


    );
  }
}

export default KeyFindingsNew;
